'use strict';

var Backbone    = require('backbone');

// Get all the client routes from the generated file
var routesAll = require('./../../config/compiled/routes.json').routes_server,
    routes = {};

for (var i = 0; i < routesAll.length; i++) {

    var data = routesAll[i].data;

    for (var j = 0; j < data.length; j++) {

        var route = data[j].view.route,
            alias = data[j].view.alias;

        // console.log(`routes['${route}'] = '${alias}';`);
        routes[route] = alias;
    }
}

// Set all the client routes
// console.log('routes ==>', routes);
var Router = Backbone.Router.extend({
    routes: routes
});

module.exports = new Router();
